export default {
  delete: ({ DELETE }, cabinet) =>
    new Promise((resolve, reject) => {
      if (!cabinet.getId()) {
        return reject(new Error(`Erreur paramètre : cabinet ID non valide`))
      }
      return DELETE(`cabinets/${cabinet.getId()}`)
        .then((reponse) => {
          const data = reponse.data
          if ([200, 204].includes(reponse.status)) {
            resolve(data)
          } else {
            reject(reponse.status)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
}
